import React, { useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import PrivateRoute from 'components/Navigation/ProtectedRoute';
import UserModalContent from './ActionModalContent';
import SolidButton from 'components/SolidButton';
import Table from 'components/Table';
import Modal from 'components/Modal';

import PaginationApi from 'utils/paginationApi';
import { formatDate } from 'utils/functions';
import { IUser } from 'utils/interfaces';
import { useAuth } from 'contexts/Auth';
import { BUTTON_COLORS } from 'utils/enums';
import CompanyModalContent from '../Companies/Modal';
import GeneralApi from 'utils/generalApi';
import { cleanObject } from 'utils/functions';

export default function UsersPage() {
  const history = useNavigate();
  const auth = useAuth();
  const generalApi = useMemo(() => new GeneralApi(auth, history), [auth, history]);

  const usersApi = useMemo(
    () => new PaginationApi('/users/list', 10, auth, history),
    [auth, history]
  );

  const handleDelete = async (item: IUser) => {
    const confirmDelete = window.confirm(
      `¿Seguro que deseas eliminar al usuario ${item.first_name}?`
    );

    if (!confirmDelete) return;

    try {
      setLoading(true);
      var resquest = {
        "userId": item._id,
      }
      await generalApi.post('/users/delete2', {
        ...cleanObject(resquest)
      })

      setRefresh(false);
      setTimeout(() => setRefresh(true), 0);

    } catch (error) {
      console.error(error);
      alert("Error al eliminar el usuario");
    } finally {
      setLoading(false);
    }
  };

  const [refresh, setRefresh] = useState(true);
  const [loading, setLoading] = useState(false);
  const [users, setUsers] = useState<Array<IUser>>([]);

  const [isActionOpen, setIsActionOpen] = useState(false);
  const [actionData, setActionData] = useState<IUser | undefined>(undefined);

  const [isActionOpenCompany, setIsActionOpenCompany] = useState(false);

  return (
    <PrivateRoute>
      <div className="mx-auto h-full max-w-7xl px-1 py-8 text-[#1B205A] lg:py-16">
        <Modal size="large" isOpen={isActionOpen} onClose={() => setIsActionOpen(false)}>
          <UserModalContent
            title={actionData ? 'Editar empresa' : 'Crear empresa'}
            actionData={actionData}
            onClose={() => setIsActionOpen(false)}
            onSuccess={() => {
              setRefresh(true);
              setIsActionOpen(false);
            }}
          />
        </Modal>
        <Modal size="base" isOpen={isActionOpenCompany} onClose={() => setIsActionOpenCompany(false)}>
          <CompanyModalContent
            title={"Lista de empresas"}
            actionData={actionData}
            onClose={() => setIsActionOpenCompany(false)}
            onSuccess={() => {
              setRefresh(true);
              setIsActionOpenCompany(false);
            }}
          />
        </Modal>
        <div className="mb-3 flex items-center justify-between">
          <h1 className="text-3xl font-bold text-primary-base">USUARIOS</h1>

          <div className="flex gap-2 ml-auto">
            {/* <SolidButton className="w-auto" color={BUTTON_COLORS.YELLOW}  onClick={() => setIsActionOpenCompany(true)}>
              Agregar Organización
            </SolidButton> */}
            <SolidButton className="w-auto" onClick={() => {
              setActionData(undefined);
              setIsActionOpen(true)
            }}>
              Agregar empresa
            </SolidButton>
          </div>
        </div>

        <Table
          isLoading={loading}
          setIsLoading={setLoading}
          loadingText="Buscando usuarios"
          columns={[
            
            {
              title: 'Acciones',
              dataKey: 'id',
              disableSort: true,
              render: (item: IUser) => (
                <div className="flex gap-2 items-center justify-center">
                  <SolidButton
                    className="w-auto"
                    size="sm"
                    onClick={() => {
                      setActionData(item);
                      setIsActionOpen(true);
                    }}
                  >
                    Editar
                  </SolidButton>
                    <SolidButton
                    color= {BUTTON_COLORS.ORANGE}
                    className="w-auto"
                    size="sm"
                    onClick={() => {
                      setActionData(item);
                      setIsActionOpenCompany(true);
                    }}
                  >
                    Asignar Empresas
                  </SolidButton>
                  <SolidButton
                    color= {BUTTON_COLORS.RED}
                    className="w-auto"
                    size="sm"
                    onClick={() => {
                      handleDelete(item);
                    }}
                  >
                    Eliminar
                  </SolidButton>
                </div>
              ),
            },
            {
              title: 'RUC',
              dataKey: 'company.ruc',
              disableSort: true,
            },
            {
              title: 'Empresa',
              dataKey: 'company.bussiness_name',
              disableSort: true,
            },
            {
              title: 'Dirección',
              dataKey: 'company.address',
              disableSort: true,
            },
            {
              title: 'Trabajadores',
              dataKey: 'company.workers_amount',
              disableSort: true,
              type: 'number',
            },
            {
              title: 'Nombres',
              dataKey: 'first_name',
            },
            {
              title: 'Apellidos',
              dataKey: 'last_name_p',
              type: 'combo',
              list: ['last_name_p', 'last_name_m'],
              render: (item: IUser) => `${item.last_name_p} ${item.last_name_m}`,
            },
            {
              title: 'DNI',
              dataKey: 'dni',
            },
            {
              title: 'Email',
              dataKey: 'email',
            },
            {
              title: 'Licencia',
              dataKey: 'company.license',
              disableSort: true,
              render: (item: IUser) =>
                item.company?.license
                  ? `${item.company.yearly_record_count || 0} de ${
                      item.company.license.max_records
                    }`
                  : '',
            },
            {
              title: 'Fecha de creación',
              dataKey: 'created_at',
              type: 'date',
              render: (item: IUser) => formatDate(new Date(item.created_at), 'dd/MM/yyyy', false),
            },
          ]}
          data={users}
          setData={setUsers}
          dataApi={usersApi}
          refresh={refresh}
          setRefresh={setRefresh}
        />
      </div>
    </PrivateRoute>
  );
}
